import { filterSliderConstant, IFilterSliderConstants } from '../../constants/filter/slider/filterSliderConstant';
import { IFilter } from '../../interfaces/Filter.interfaces';

interface IResetFilterOptionIsSelectedParams {
  currentFilters: IFilter[];
  targetFilter?: IFilter;
}

export const resetFilterOptionIsSelected = ({
  currentFilters,
  targetFilter,
}: IResetFilterOptionIsSelectedParams): IFilter[] => {
  const newProductFilters = currentFilters.map((filter) => {
    // 타겟 필터가 없는 경우 => 전체 필터 초기화
    // 타켓 필터가 있는 경우 => 타겟 필터만 초기화
    if (!targetFilter || (targetFilter && targetFilter.key === filter.key)) {
      if (filter.optionType === 'checkbox' || filter.optionType === 'radio') {
        const newOptions = filter.options.map((option) => {
          if (option.isDefault) {
            option.isSelected = true;
          } else {
            option.isSelected = false;
          }
          return option;
        });
        return { ...filter, options: newOptions };
      }

      if (filter.optionType === 'slider') {
        const newOptions = filter.options.map((option) => {
          // 직거래 필터처럼 공용 슬라이더 범위를 쓰지 않는 필터가 있어, 옵션이 가진 기본값을 우선한다.
          if (option.defaultValue !== undefined) {
            option.value = option.defaultValue;
            return option;
          }
          if (filter.key in filterSliderConstant && option.optionName === 'min') {
            option.value = filterSliderConstant[filter.key as keyof IFilterSliderConstants].min;
          }
          if (filter.key in filterSliderConstant && option.optionName === 'max') {
            option.value = filterSliderConstant[filter.key as keyof IFilterSliderConstants].max;
          }
          return option;
        });
        return { ...filter, options: newOptions };
      }
    }

    return filter;
  });

  return newProductFilters;
};
